import React, { useEffect } from 'react'
import { map, pipe, prop, sum } from 'lodash/fp'
import { OctagonAlertIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useSelectedCurrency } from '@/entities/currency'
import { usePricingAlertsQuery } from '@/entities/price-alert'

import { Button } from '@/shared/components/ui/button'
import { Spinner } from '@/shared/components/ui/spinner'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { ampli } from '@/shared/lib/ampli'
import { useDrawers } from '@/shared/lib/drawer-manager'

const getAlertsProductsTotalCount = pipe([
	prop('by_level'),
	map(prop('products')),
	sum,
])

export function GlobalPricingAlertsTrigger() {
	const { t } = useTranslation()
	const currency = useSelectedCurrency()
	const { openDrawer, closeDrawer } = useDrawers()
	useEffect(
		() => () => {
			closeDrawer('PRICING_ALERTS')
		},
		[]
	)

	const { data, isLoading } = usePricingAlertsQuery<number>(
		{ currency },
		{
			select: getAlertsProductsTotalCount,
		}
	)

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					onClick={() => {
						ampli.alertsOpenClicked({
							alerts_of: 'assortment',
						})
						openDrawer('PRICING_ALERTS', {
							type: 'global',
							drawerClassName: 'assortment-alerts-eastside',
						})
					}}
					className='relative'
					size='icon'
				>
					{isLoading ? <Spinner /> : <OctagonAlertIcon />}
					{data ? (
						<span className='absolute -top-1 -right-1 flex size-3 ease-in-out'>
							<span className='absolute inline-flex size-full animate-ping rounded-full bg-destructive/50' />
							<span className='relative inline-flex size-3 rounded-full bg-destructive' />
						</span>
					) : null}
				</Button>
			</TooltipTrigger>
			<TooltipContent side='top' align='end'>
				{t('app.pricing_alerts', {
					defaultValue: 'Pricing alerts',
				})}
			</TooltipContent>
		</Tooltip>
	)
}
